import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const initChallangesSwiper = () => {
  const blocks = document.querySelectorAll('.wp-block-lb-cpt-herausforderungen');

  blocks.forEach((section) => {
    const swiperContainer = section.querySelector('.cards-challenges-swiper');
    if (!swiperContainer) return;

    new Swiper(swiperContainer, {
      modules: [Navigation],
      slidesPerView: 1.13,
      spaceBetween: 16,
      freeMode: true,

      navigation: {
        nextEl: section.querySelector('.cards-challenges-navigation .swiper-btn-next'),
        prevEl: section.querySelector('.cards-challenges-navigation .swiper-btn-prev'),
      },

      breakpoints: {
        576: {
          slidesPerView: 1.8,
        },
        768: {
          slidesPerView: 2.2,
          freeMode: false,
        },
        992: {
          slidesPerView: 3.5,
        },
        1200: {
          slidesPerView: 4.5,
        },
        1600: {
          slidesPerView: 4,
        },
      },
    });
  });
};

document.addEventListener('DOMContentLoaded', initChallangesSwiper);
